/**
 * @generated SignedSource<<3739ff3c522669a8fe5ee494d0a8f96a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type RegistryAccessLevels = "READ_AND_WRITE" | "READ_ONLY" | "READ_WRITE_AND_ADMIN" | "%future added value";
export type TeamRegistryUpdateInput = {
  accessLevel: RegistryAccessLevels;
  clientMutationId?: string | null;
  id: string;
};
export type RegistriesTeamAccessLevelChangeMutation$variables = {
  input: TeamRegistryUpdateInput;
};
export type RegistriesTeamAccessLevelChangeMutation$data = {
  readonly teamRegistryUpdate: {
    readonly teamRegistry: {
      readonly accessLevel: RegistryAccessLevels;
    };
  } | null;
};
export type RegistriesTeamAccessLevelChangeMutation = {
  response: RegistriesTeamAccessLevelChangeMutation$data;
  variables: RegistriesTeamAccessLevelChangeMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "accessLevel",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RegistriesTeamAccessLevelChangeMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "TeamRegistryUpdatePayload",
        "kind": "LinkedField",
        "name": "teamRegistryUpdate",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "TeamRegistry",
            "kind": "LinkedField",
            "name": "teamRegistry",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RegistriesTeamAccessLevelChangeMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "TeamRegistryUpdatePayload",
        "kind": "LinkedField",
        "name": "teamRegistryUpdate",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "TeamRegistry",
            "kind": "LinkedField",
            "name": "teamRegistry",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "66ec22a67f22ff406258bf69d8e34076",
    "id": null,
    "metadata": {},
    "name": "RegistriesTeamAccessLevelChangeMutation",
    "operationKind": "mutation",
    "text": "mutation RegistriesTeamAccessLevelChangeMutation(\n  $input: TeamRegistryUpdateInput!\n) {\n  teamRegistryUpdate(input: $input) {\n    teamRegistry {\n      accessLevel\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "746334c390fa220174aaa31dd8e53f25";

export default node;
